// export const API_BASE_URL = "https://purnaacademic.in/";
export const API_BASE_URL = "http://192.168.29.113:1010/";

export const CONTACT_FORM_ENDPOINT = API_BASE_URL + "visitNow/sendVisitMail";